import { styled as muiStyled } from "@mui/material/styles";
import styled from "styled-components";
import TableCell from "@mui/material/TableCell";
import theme from "../../styles/theme";

// Common styled components for tables
export const StyledTableCell = muiStyled(TableCell)`
  color: #67676d;
  font-size: 10px;
  font-weight: bold;
  font-family: "Montserrat", sans-serif;
  border-bottom: 2px solid ${theme.colors.secondaryDark};
  padding: 0 8px;
  height: 15px;
`;

export const StyledTableCellRow = muiStyled(TableCell)`
  color: white;
  font-size: 12px;
  font-weight: 400;
  font-family: "Montserrat", sans-serif;
  border-bottom: 2px solid ${theme.colors.secondaryDark};
  padding: 0 8px;
  height: 40px;
`;

export const TableTitle = styled.div`
  font-family: "Montserrat", sans-serif;
  margin-bottom: 16px;
  font-size: 16px;
  font-weight: bold;
  padding: 0px;
`;

export const NoDataMessage = styled.div`
  padding: 16px;
  text-align: center;
  color: ${theme.colors.grey};
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
`;

export const PointsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px 0px;
  justify-content: center;
`;

export const ResultContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

// Common table container styles
export const tableContainerStyles = {
  backgroundColor: "transparent",
  boxShadow: "none",
  background: "#2a2a2ac4",
  padding: "12px",
  border: "2px solid #393B40",
  whiteSpace: "nowrap",
};
